var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button-header"},[_c('a-button',{staticClass:"w95",attrs:{"type":"primary"},on:{"click":_vm.toCourseEdit}},[_vm._v(_vm._s(_vm.title))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }